import { Component, inject, ViewChild, AfterViewInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Firestore, Timestamp, arrayRemove, arrayUnion, doc, getDoc, setDoc } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { signOut } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { collection, onSnapshot, query, orderBy, getDocsFromServer, where, limit, startAfter, QueryConstraint, QueryDocumentSnapshot } from '@angular/fire/firestore';
import { OnDestroy } from '@angular/core';
import { updateDoc, serverTimestamp} from '@angular/fire/firestore';
/* Angular Material */
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { UserContextService } from '../user-context.service';
import { TelegramService } from '../telegram.service';
import { TRACKED_SECTIONS, VisitorTrackingService } from '../visitor-tracking.service';



const ICON_MAP: Record<string, string> = {
// Add these to your ICON_MAP:

  // Musculoskeletal Conditions
  Bone: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5 .5.5 0 0 0 .5.5 2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z"></path>
    </svg>
  `,

  Accessibility: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <circle cx="16" cy="4" r="1"></circle>
      <path d="m18 19 1-7c0-1-.6-2-2-2H9c-1.4 0-2 1-2 2l1 7"></path>
      <path d="m5 8 3-3 5.5 3-2.36 3.5"></path>
      <path d="M4.24 14.5a5 5 0 0 0 6.88 6"></path>
      <path d="M13.76 17.5a5 5 0 0 0-6.88-6"></path>
    </svg>
  `,

  // Physio-Assisted Fitness Program
  Dumbbell: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M14.4 14.4 9.6 9.6"></path>
      <path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"></path>
      <path d="m21.5 21.5-1.4-1.4"></path>
      <path d="M3.9 3.9 2.5 2.5"></path>
      <path d="M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"></path>
    </svg>
  `,

  Target: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <circle cx="12" cy="12" r="6"></circle>
      <circle cx="12" cy="12" r="2"></circle>
    </svg>
  `,

  // Women's Health Program
  Heart: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
    </svg>
  `,

  Flower: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 7.5a4.5 4.5 0 1 1 4.5 4.5M12 7.5A4.5 4.5 0 1 0 7.5 12M12 7.5V9m-4.5 3a4.5 4.5 0 1 0 4.5 4.5M7.5 12H9m7.5 0a4.5 4.5 0 1 1-4.5 4.5m4.5-4.5H15m-3 4.5V15"></path>
      <circle cx="12" cy="12" r="3"></circle>
      <path d="m8 16 1.5-1.5"></path>
      <path d="M14.5 9.5 16 8"></path>
      <path d="m8 8 1.5 1.5"></path>
      <path d="M14.5 14.5 16 16"></path>
    </svg>
  `,

  // Sports Injury Management
  Zap: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    </svg>
  `,

  Bandage: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="6" width="18" height="12" rx="2"></rect>
      <path d="M10 12h.01"></path>
      <path d="M14 12h.01"></path>
      <path d="M10 16h.01"></path>
      <path d="M14 16h.01"></path>
      <path d="M10 8h.01"></path>
      <path d="M14 8h.01"></path>
    </svg>
  `,

  CrosshairIcon: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="22" y1="12" x2="18" y2="12"></line>
      <line x1="6" y1="12" x2="2" y2="12"></line>
      <line x1="12" y1="6" x2="12" y2="2"></line>
      <line x1="12" y1="22" x2="12" y2="18"></line>
    </svg>
  `,

  Footprints: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"></path>
      <path d="M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"></path>
    </svg>
  `,

  Move: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <polyline points="5 9 2 12 5 15"></polyline>
      <polyline points="9 5 12 2 15 5"></polyline>
      <polyline points="15 19 12 22 9 19"></polyline>
      <polyline points="19 9 22 12 19 15"></polyline>
      <line x1="2" y1="12" x2="22" y2="12"></line>
      <line x1="12" y1="2" x2="12" y2="22"></line>
    </svg>
  `,
  HandHelping: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14"></path>
      <path d="m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"></path>
      <path d="m2 13 6 6"></path>
    </svg>
  `,
  User: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  `,
  HeartPulse: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
      <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"></path>
    </svg>
  `,
  Activity: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
    </svg>
  `,
  Dumbbell2: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M6 5v14"></path>
      <path d="M18 5v14"></path>
      <path d="M2 9v6"></path>
      <path d="M22 9v6"></path>
      <path d="M6 12h12"></path>
    </svg>
  `,
  Bone2: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 6a3 3 0 1 1 4-4l10 10a3 3 0 1 1-4 4L5 6Z"></path>
    </svg>
  `,
  Stethoscope: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 2v6a4 4 0 0 0 8 0V2"></path>
      <path d="M12 12a4 4 0 0 0 8 0"></path>
      <circle cx="20" cy="12" r="2"></circle>
    </svg>
  `,
  Calendar: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  `,
  Clock: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  `,
  Shield: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 2l8 4v6c0 5-3.5 9.5-8 10-4.5-.5-8-5-8-10V6l8-4Z"></path>
    </svg>
  `,
  CheckCircle: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="9 12 12 15 17 9"></polyline>
    </svg>
  `,
  PlusCircle: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="16"></line>
      <line x1="8" y1="12" x2="16" y2="12"></line>
    </svg>
  `,
  Location: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0Z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  `,
  Phone: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2
              19.79 19.79 0 0 1-8.63-3.07
              19.5 19.5 0 0 1-6-6
              19.79 19.79 0 0 1-3.07-8.67
              A2 2 0 0 1 4.11 2h3
              a2 2 0 0 1 2 1.72
              12.84 12.84 0 0 0 .7 2.81
              2 2 0 0 1-.45 2.11
              L8.09 9.91
              a16 16 0 0 0 6 6
              l1.27-1.27
              a2 2 0 0 1 2.11-.45
              12.84 12.84 0 0 0 2.81.7
              A2 2 0 0 1 22 16.92z">
      </path>
    </svg>
  `,
    Thermometer: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4 4 0 1 0 5 0Z"></path>
      </svg>
    `,

    Clipboard: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <rect x="9" y="2" width="6" height="4" rx="1"></rect>
        <path d="M9 4H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2"></path>
      </svg>
    `,

    FileText: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
      </svg>
    `,

    Award: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="8" r="6"></circle>
        <path d="M15.5 14 17 22l-5-3-5 3 1.5-8"></path>
      </svg>
    `,

    TrendingUp: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
        <polyline points="17 6 23 6 23 12"></polyline>
      </svg>
    `,

    AlertCircle: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    `,

    RefreshCw: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10"></path>
        <path d="M20.49 15a9 9 0 0 1-14.13 3.36L1 14"></path>
      </svg>
    `,

    Layers: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <polygon points="12 2 22 8 12 14 2 8"></polygon>
        <polyline points="2 17 12 22 22 17"></polyline>
        <polyline points="2 12 12 17 22 12"></polyline>
      </svg>
    `,

    Smile: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
        <line x1="9" y1="9" x2="9.01" y2="9"></line>
        <line x1="15" y1="9" x2="15.01" y2="9"></line>
      </svg>
    `,

    Settings: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33"></path>
        <path d="M4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33"></path>
        <path d="M12 2v2"></path>
        <path d="M12 20v2"></path>
        <path d="M20 12h2"></path>
        <path d="M2 12h2"></path>
      </svg>
    `


};

interface Service {
  id: number;
  name: string;
  description: string;
  // icon: string;
  icon: {
    key: string;
    svg: string;
  };

  featured: boolean;
}
interface Faq {
  id: number;
  question: string;
  answer: string;
  isOpen: boolean;
}

interface Doctor {
  id: number;
  doctorname: string;
  qualification: string;
  specialization: string;
  experience: number;
  imageurl: string;
}

interface Testimonial {
  id: number;
  patientName: string;
  testimonial: string;
  rating: number;
}

interface VisitorLogRow {
  id: string;
  startedAt: Date | null;
  durationSeconds: number;
  sections: { key: string; label: string; seconds: number }[];  // in the order viewed
  exitSection: string;
  device: string;
  browser: string;
  os: string;
  source: string;
  visitorId: string;
  isReturning: boolean;
  visitNumber: number;
  bookedAppointment: boolean;
}

interface SectionStat {
  label: string;
  seconds: number;
  reachPercent: number;  // % of visits that saw this section
  barPercent: number;    // bar width relative to the most-viewed section
}

@Component({
  selector: 'app-adminpage',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatChipsModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  templateUrl: './adminpage.component.html',
  styleUrl: './adminpage.component.css'
})
export class AdminpageComponent implements AfterViewInit, OnDestroy {

  private firestore = inject(Firestore);
  private fb = inject(FormBuilder);
  private auth = inject(Auth);
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);
  private userContext = inject(UserContextService);
  private telegram = inject(TelegramService);
  iconList = Object.keys(ICON_MAP);

  appointments: any[] = [];
  appointmentsUnsub: (() => void) | null = null;
  filteredAppointments: any[] = [];

  filterStatus: string = '';
  sortField: 'preferredDate' | 'created' = 'preferredDate';
  sortOrder: 'asc' | 'desc' = 'desc';

  // SERVICE TYPES
  serviceTypeInput = '';
  serviceTypes: string[] = [];

  // SERVICES
  serviceForm!: FormGroup;
  services: Service[] = [];
  editingServiceId: number | null = null;
  serviceDS = new MatTableDataSource<Service>();
  serviceColumns = ['name', 'description', 'icon', 'featured', 'actions'];

  // DOCTORS
  doctorForm!: FormGroup;
  doctors: Doctor[] = [];
  editingDoctorId: number | null = null;
  doctorDS = new MatTableDataSource<Doctor>();
  doctorColumns = ['doctorname', 'qualification', 'specialization', 'experience', 'image', 'actions'];

  // TESTIMONIALS
  testimonialForm!: FormGroup;
  testimonials: Testimonial[] = [];
  editingTestimonialId: number | null = null;
  testimonialDS = new MatTableDataSource<Testimonial>();
  testimonialColumns = ['patientName', 'testimonial', 'rating', 'actions'];

  //FAQ
  faqForm!: FormGroup;
  faq: Faq[] = [];
  editingFaqId: number | null = null;
  faqDS = new MatTableDataSource<Faq>();
  faqColumns = ['question', 'answer', 'isopen','actions'];

  // VISITOR LOGS
  private tracking = inject(VisitorTrackingService);
  private sectionLabels = new Map(TRACKED_SECTIONS.map(s => [s.key, s.label]));
  readonly visitorPageSize = 100;           // visits per Load / Load more press
  today = new Date();                       // latest date the range picker allows (see refreshToday)
  visitorLogDS = new MatTableDataSource<VisitorLogRow>();
  visitorLogColumns = ['startedAt', 'durationSeconds', 'sections', 'exitSection', 'device', 'source', 'visitor', 'booked'];
  visitorRange: 'today' | '7d' | '30d' | 'custom' = 'today';
  customFrom: Date | null = null;
  customTo: Date | null = null;
  visitorLogsLoading = false;
  visitorLogsLoaded = false;
  visitorHasMore = false;
  visitorLoadedLabel = '';                  // the period the table is showing
  private visitorRows: VisitorLogRow[] = [];
  private visitorLoadedRange: { from: Date; to: Date } | null = null;
  private visitorLastDoc: QueryDocumentSnapshot | null = null;
  private visitorLoadSeq = 0;
  visitorLogsError = '';
  visitorStats = { visits: 0, uniqueVisitors: 0, avgSeconds: 0, booked: 0, topSection: '—' };
  sectionStats: SectionStat[] = [];
  excludeThisBrowser = false;

  // iconList = ['HandHelping', 'User', 'HeartPulse'];

  timeConfigForm!: FormGroup;
  weekDays = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
  minTempHolidayDate = new Date();


  // Paginators
  @ViewChild('servicePaginator') servicePaginator!: MatPaginator;
  @ViewChild('doctorPaginator') doctorPaginator!: MatPaginator;
  @ViewChild('testimonialPaginator') testimonialPaginator!: MatPaginator;
  @ViewChild('faqPaginator') faqPaginator!: MatPaginator;
  @ViewChild('visitorLogPaginator') visitorLogPaginator!: MatPaginator;

  // Sorts
  @ViewChild('serviceSort') serviceSort!: MatSort;
  @ViewChild('doctorSort') doctorSort!: MatSort;
  @ViewChild('testimonialSort') testimonialSort!: MatSort;
  @ViewChild('faqSort') faqSort!: MatSort;
  @ViewChild('visitorLogSort') visitorLogSort!: MatSort;

  private platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    this.initForms();

    if (isPlatformBrowser(this.platformId)) {
      this.loadServices();
      this.loadFaq();
      this.loadDoctors();
      this.loadTestimonials();
      this.loadServiceTypes();
      this.loadAppointments();
      this.loadTimeConfigurationForAdmin();
      // visitor logs are only read when the admin presses Load (see loadVisitorLogs)
      this.excludeThisBrowser = this.tracking.isOptedOut();
    }
  }

  // constructor() {
  //   this.initForms();
  //   this.loadServices();
  //   this.loadFaq();
  //   this.loadDoctors();
  //   this.loadTestimonials();
  //   this.loadServiceTypes();
  //   this.loadAppointments();
  // }

  ngAfterViewInit() {
    this.serviceDS.paginator = this.servicePaginator;
    this.serviceDS.sort = this.serviceSort;

    this.doctorDS.paginator = this.doctorPaginator;
    this.doctorDS.sort = this.doctorSort;

    this.testimonialDS.paginator = this.testimonialPaginator;
    this.testimonialDS.sort = this.testimonialSort;

    this.faqDS.paginator = this.faqPaginator;
    this.faqDS.sort = this.faqSort;

    this.visitorLogDS.paginator = this.visitorLogPaginator;
    this.visitorLogDS.sort = this.visitorLogSort;
    this.visitorLogDS.sortingDataAccessor = (row, column) =>
      column === 'startedAt' ? row.startedAt?.getTime() ?? 0
        : column === 'durationSeconds' ? row.durationSeconds
        : '';
  }
  ngOnDestroy() {
    if (this.appointmentsUnsub) {
      this.appointmentsUnsub();
    }
  }

  initForms() {
    this.timeConfigForm = this.fb.group({

      starttime: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(0?[1-9]|1[0-2]):[0-5][0-9](AM|PM)$/)
        ]
      ],

      endtime: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(0?[1-9]|1[0-2]):[0-5][0-9](AM|PM)$/)
        ]
      ],

      holiday: [
        [],
        Validators.required
      ],

      visitdurationminutes: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(?:[1-9][0-9]?|1[01][0-9]|120)$/)
        ]
      ],

      temporaryholiday: [[]]

    });

    this.serviceForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      icon: ['', Validators.required],
      featured: [false]
    });
    this.faqForm = this.fb.group({
      question: ['', Validators.required],
      answer: ['', Validators.required],
      isOpen: [false]
    });

    this.doctorForm = this.fb.group({
      doctorname: ['', Validators.required],
      qualification: ['', Validators.required],
      specialization: ['', Validators.required],
      experience: ['', [Validators.required]],
      imageurl: ['', Validators.required]
    });

    this.testimonialForm = this.fb.group({
      patientName: ['', Validators.required],
      testimonial: ['', Validators.required],
      rating: ['', [Validators.required, Validators.min(1), Validators.max(5)]]
    });
  }
  addTemporaryHoliday(date: Date | null) {
    if (!date) return;

    const current =
      this.timeConfigForm.get('temporaryholiday')?.value || [];

    // prevent duplicate dates (same day)
    const exists = current.some((d: Date) =>
      new Date(d).toDateString() === new Date(date).toDateString()
    );

    if (exists) return;

    this.timeConfigForm.patchValue({
      temporaryholiday: [...current, date]
    });
  }

  removeTemporaryHoliday(index: number) {
    const current =
      this.timeConfigForm.get('temporaryholiday')?.value || [];

    const updated = current.filter((_: any, i: number) => i !== index);

    this.timeConfigForm.patchValue({
      temporaryholiday: updated
    });
  }

  loadTimeConfigurationForAdmin() {

    if (!isPlatformBrowser(this.platformId)) return;

    const ref = doc(this.firestore, 'settings', 'time configuration');

    onSnapshot(ref, snap => {

      if (!snap.exists()) return;

      const d = snap.data();

      this.timeConfigForm.patchValue({
        starttime: d['starttime'] || '',
        endtime: d['endtime'] || '',
        holiday: d['holiday'] || [],
        visitdurationminutes: d['visitdurationminutes'] || '',
        temporaryholiday: (d['temporaryholiday'] || []).map((x: any) => x.toDate())
      });

    });
  }
  isEndTimeInvalid(): boolean {

    if(this.timeConfigForm.get('endtime')?.invalid ||
      this.timeConfigForm.get('starttime')?.invalid) return false;

    const s = this.timeConfigForm.value.starttime;
    const e = this.timeConfigForm.value.endtime;

    const toMin = (v:string)=>{
      const m = v.match(/(\d+):(\d+)(AM|PM)/)!;
      let h = +m[1], min = +m[2];
      if(m[3]==='PM' && h!==12) h+=12;
      if(m[3]==='AM' && h===12) h=0;
      return h*60+min;
    };

    return toMin(e) <= toMin(s);
  }

  async saveTimeConfiguration(){

    if(this.timeConfigForm.invalid){
      this.timeConfigForm.markAllAsTouched();
      return;
    }

    const v = this.timeConfigForm.value;

    await setDoc(
      doc(this.firestore,'settings','time configuration'),
      {
        starttime: v.starttime,
        endtime: v.endtime,
        holiday: v.holiday,
        visitdurationminutes: Number(v.visitdurationminutes),
        temporaryholiday: (v.temporaryholiday || []).map((d: Date) =>
          Timestamp.fromDate(new Date(d))
        )
      },
      { merge:true }
    );
  }

  async loadAppointments() {
    if (!isPlatformBrowser(this.platformId)) return;

    const q = query(
      collection(this.firestore, 'appointments'),
      orderBy('created', 'desc')
    );

    this.appointmentsUnsub = onSnapshot(q, (snapshot) => {
      this.appointments = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.applyFilters();
    });
  }

  // async loadAppointments() {

  //   const q = query(
  //     collection(this.firestore, 'appointments'),
  //     orderBy('created', 'desc')
  //   );

  //   this.appointmentsUnsub = onSnapshot(q, (snapshot) => {
  //     this.appointments = snapshot.docs.map(doc => ({
  //       id: doc.id,
  //       ...doc.data()
  //     }));
  //     this.applyFilters();
  //     console.log('Realtime Appointments:', this.appointments);
  //   });
  // }
  applyFilters() {
    let data = [...this.appointments];

    // FILTER BY STATUS
    if (this.filterStatus) {
      data = data.filter(a => a.status === this.filterStatus);
    }

    // SORT
    data.sort((a, b) => {
      const aDate = a[this.sortField]?.toDate?.() ?? new Date(0);
      const bDate = b[this.sortField]?.toDate?.() ?? new Date(0);

      return this.sortOrder === 'asc'
        ? aDate.getTime() - bDate.getTime()
        : bDate.getTime() - aDate.getTime();
    });

    this.filteredAppointments = data;
  }
  toggleSortOrder() {
    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    this.applyFilters();
  }
  async loadServices() {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'services'));
    this.services = snap.exists() ? snap.data()['services'] || [] : [];
    this.serviceDS.data = [...this.services];
  }

  // async loadServices() {
  //   const snap = await getDoc(doc(this.firestore, 'webdata', 'services'));
  //   this.services = snap.exists() ? snap.data()['services'] || [] : [];
  //   this.serviceDS.data = [...this.services];
  // }
  // async loadFaq() {
  //   const snap = await getDoc(doc(this.firestore, 'webdata', 'faq'));
  //   this.faq = snap.exists() ? snap.data()['faq'] || [] : [];
  //   this.faqDS.data = [...this.faq];
  // }
  
  async loadFaq() {
  if (!isPlatformBrowser(this.platformId)) return;

  const snap = await getDoc(doc(this.firestore, 'webdata', 'faq'));
  this.faq = snap.exists() ? snap.data()['faq'] || [] : [];
  this.faqDS.data = [...this.faq];
}
async loadServiceTypes() {
  if (!isPlatformBrowser(this.platformId)) return;

  const snap = await getDoc(doc(this.firestore, 'webdata', 'servicetypes'));
  this.serviceTypes = snap.exists()
    ? snap.data()['services'] || []
    : [];
}

  // async loadServiceTypes() {
  //   const snap = await getDoc(doc(this.firestore, 'webdata', 'servicetypes'));
  //   this.serviceTypes = snap.exists() ? snap.data()['services'] || [] : [];
  // }

  async saveService() {
    if (this.serviceForm.invalid) return;

    const iconKey = this.serviceForm.value.icon;

    const serviceData: Service = {
      id: this.editingServiceId ?? Date.now(),
      name: this.serviceForm.value.name,
      description: this.serviceForm.value.description,
      featured: this.serviceForm.value.featured,
      icon: {
        key: iconKey,
        svg: ICON_MAP[iconKey]
      }
    };

    if (this.editingServiceId) {
      const i = this.services.findIndex(s => s.id === this.editingServiceId);
      this.services[i] = serviceData;
    } else {
      this.services.push(serviceData);
    }

    await setDoc(doc(this.firestore, 'webdata', 'services'), {
      services: this.services
    });

    this.resetServiceForm();
    this.serviceDS.data = [...this.services];
  }


  editService(s: Service) {
    this.editingServiceId = s.id;

    this.serviceForm.patchValue({
      name: s.name,
      description: s.description,
      featured: s.featured,
      icon: s.icon.key
    });
  }


  async deleteService(id: number) {
    if (!confirm('Delete this service?')) return;
    this.services = this.services.filter(s => s.id !== id);
    await setDoc(doc(this.firestore, 'webdata', 'services'), { services: this.services });
    this.serviceDS.data = [...this.services];
  }

  resetServiceForm() {
    this.editingServiceId = null;
    this.serviceForm.reset({ featured: false });
  }

  //faq


  async saveFaq() {
    if (this.faqForm.invalid) return;

    const faqData: Faq = {
      id: this.editingFaqId ?? Date.now(),
      question: this.faqForm.value.question,
      answer: this.faqForm.value.answer,
      isOpen: this.faqForm.value.isOpen,
    };

    if (this.editingFaqId) {
      const i = this.faq.findIndex(s => s.id === this.editingFaqId);
      this.faq[i] = faqData;
    } else {
      this.faq.push(faqData);
    }

    await setDoc(doc(this.firestore, 'webdata', 'faq'), {
      faq: this.faq
    });

    this.resetFaqForm();
    this.faqDS.data = [...this.faq];
  }


  editFaq(s: Faq) {
    this.editingFaqId = s.id;

    this.faqForm.patchValue({
      question: s.question,
      answer: s.answer,
      isOpen: s.isOpen,
    });
  }


  async deleteFaq(id: number) {
    if (!confirm('Delete this faq?')) return;
    this.faq = this.faq.filter(s => s.id !== id);
    await setDoc(doc(this.firestore, 'webdata', 'faq'), { faq: this.faq });
    this.faqDS.data = [...this.faq];
  }

  resetFaqForm() {
    this.editingFaqId = null;
    this.faqForm.reset({ isOpen: false });
  }
  async loadDoctors() {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'doctors'));
    this.doctors = snap.exists() ? snap.data()['doctors'] || [] : [];
    this.doctorDS.data = [...this.doctors];
  }

  // async loadDoctors() {
  //   const snap = await getDoc(doc(this.firestore, 'webdata', 'doctors'));
  //   this.doctors = snap.exists() ? snap.data()['doctors'] || [] : [];
  //   this.doctorDS.data = [...this.doctors];
  // }

  async saveDoctor() {
    if (this.doctorForm.invalid) return;

    if (this.editingDoctorId) {
      const i = this.doctors.findIndex(d => d.id === this.editingDoctorId);
      this.doctors[i] = { id: this.editingDoctorId, ...this.doctorForm.value };
    } else {
      this.doctors.push({ id: Date.now(), ...this.doctorForm.value });
    }

    await setDoc(doc(this.firestore, 'webdata', 'doctors'), { doctors: this.doctors });
    this.resetDoctorForm();
    this.doctorDS.data = [...this.doctors];
  }

  editDoctor(d: Doctor) {
    this.editingDoctorId = d.id;
    this.doctorForm.patchValue(d);
  }

  async deleteDoctor(id: number) {
    if (!confirm('Delete this doctor?')) return;
    this.doctors = this.doctors.filter(d => d.id !== id);
    await setDoc(doc(this.firestore, 'webdata', 'doctors'), { doctors: this.doctors });
    this.doctorDS.data = [...this.doctors];
  }

  resetDoctorForm() {
    this.editingDoctorId = null;
    this.doctorForm.reset();
  }
  async loadTestimonials() {
    if (!isPlatformBrowser(this.platformId)) return;

    const snap = await getDoc(doc(this.firestore, 'webdata', 'testimonials'));
    this.testimonials = snap.exists()
      ? snap.data()['testimonials'] || []
      : [];
    this.testimonialDS.data = [...this.testimonials];
  }

  // async loadTestimonials() {
  //   const snap = await getDoc(doc(this.firestore, 'webdata', 'testimonials'));
  //   this.testimonials = snap.exists() ? snap.data()['testimonials'] || [] : [];
  //   this.testimonialDS.data = [...this.testimonials];
  // }

  async saveTestimonial() {
    if (this.testimonialForm.invalid) return;

    if (this.editingTestimonialId) {
      const i = this.testimonials.findIndex(t => t.id === this.editingTestimonialId);
      this.testimonials[i] = { id: this.editingTestimonialId, ...this.testimonialForm.value };
    } else {
      this.testimonials.push({ id: Date.now(), ...this.testimonialForm.value });
    }

    await setDoc(doc(this.firestore, 'webdata', 'testimonials'), { testimonials: this.testimonials });

    this.resetTestimonialForm();
    this.testimonialDS.data = [...this.testimonials];
  }

  editTestimonial(t: Testimonial) {
    this.editingTestimonialId = t.id;
    this.testimonialForm.patchValue(t);
  }

  async deleteTestimonial(id: number) {
    if (!confirm('Delete this testimonial?')) return;
    this.testimonials = this.testimonials.filter(t => t.id !== id);
    await setDoc(doc(this.firestore, 'webdata', 'testimonials'), { testimonials: this.testimonials });
    this.testimonialDS.data = [...this.testimonials];
  }
  async logout() {
    if (!confirm('are you sure want to logout?')) return;
    await signOut(this.auth).then(() => {
      this.router.navigate(['/login']);
    });
  }

  resetTestimonialForm() {
    this.editingTestimonialId = null;
    this.testimonialForm.reset();
  }
  getIconSvg(iconKey: string | null): SafeHtml | null {
    if (!iconKey || !ICON_MAP[iconKey]) return null;
    return this.sanitizer.bypassSecurityTrustHtml(ICON_MAP[iconKey]);
  }
  async removeServiceType(type: string) {
    this.serviceTypes = this.serviceTypes.filter(t => t !== type);

    await setDoc(
      doc(this.firestore, 'webdata', 'servicetypes'),
      { services: this.serviceTypes },
      { merge: true }
    );
  }

  async addServiceType() {
    const value = this.serviceTypeInput?.trim();
    if (!value || this.serviceTypes.includes(value)) return;

    this.serviceTypes.push(value);

    await setDoc(
      doc(this.firestore, 'webdata', 'servicetypes'),
      { services: this.serviceTypes },
      { merge: true }
    );

    this.serviceTypeInput = '';
  }
  async approveAppointment(a: any) {
    const approvedby =  this.userContext.name || 'Admin';
    await updateDoc(doc(this.firestore, 'appointments', a.id), {
      status: 'approved',
      approved: true,
      approvedAt: serverTimestamp()
    });
    this.sendTelegramMessage(`
      <b>Appointment Approved</b>
      <b>Appointment ID:</b> ${a.appointmentid}
      <b>Name:</b> ${a.patient_name}
      <b>Phone:</b> ${a.phone}
      <b>Appointment Date & Time:</b> ${this.formatFirestoreDateTime(a.preferredDate)}
      <b>Time:</b> ${a.preferredTime || 'Not specified'}
      <b>Email:</b> ${a.email}
      <b>Service:</b> ${a.service_type}
      <b>Patient Message:</b> ${a.message}
      <b>Notes:</b>
      ${this.formatNotes(a.notes)}
      <b>Status:</b> Approved
      <b>Approved by:</b> ${approvedby}
      `);
  }
  async completeAppointment(a: any) {
    const completedby =  this.userContext.name || 'Admin';
    await updateDoc(doc(this.firestore, 'appointments', a.id), {
      status: 'completed',
      completedAt: serverTimestamp()
    });
    this.sendTelegramMessage(`
      <b>Appointment Completed</b>
      <b>Appointment ID:</b> ${a.appointmentid}
      <b>Name:</b> ${a.patient_name}
      <b>Phone:</b> ${a.phone}
      <b>Appointment Date & Time:</b> ${this.formatFirestoreDateTime(a.preferredDate)}
      <b>Time:</b> ${a.preferredTime || 'Not specified'}
      <b>Email:</b> ${a.email}
      <b>Service:</b> ${a.service_type}
      <b>Patient Message:</b> ${a.message}
      <b>Notes:</b>
      ${this.formatNotes(a.notes)}
      <b>Status:</b> Completed
      <b>Completed by:</b> ${completedby}
      `);
  }
  async cancelAppointment(a: any) {
    const deniedBy =  this.userContext.name || 'Admin';
    await updateDoc(doc(this.firestore, 'appointments', a.id), {
      status: 'cancelled',
      cancelledAt: serverTimestamp()
    });
      await this.releaseAppointmentTime(a);
      this.sendTelegramMessage(`
        <b>Appointment Cancelled</b>
        <b>Appointment ID:</b> ${a.appointmentid}
        <b>Name:</b> ${a.patient_name}
        <b>Phone:</b> ${a.phone}
        <b>Appointment Date & Time:</b> ${this.formatFirestoreDateTime(a.preferredDate)}
        <b>Time:</b> ${a.preferredTime || 'Not specified'}
        <b>Email:</b> ${a.email}
        <b>Service:</b> ${a.service_type}
        <b>Patient Message:</b> ${a.message}
        <b>Notes:</b>
        ${this.formatNotes(a.notes)}
        <b>Status:</b> Cancelled
        <b>Cancelled by:</b> ${deniedBy}
        `);
  }

  async denyAppointment(a: any) {
    const deniedBy =  this.userContext.name || 'Admin';
    await updateDoc(
      doc(this.firestore, 'appointments', a.id),
      {
        status: 'denied',
        approved: false
      }
    );
    await this.releaseAppointmentTime(a);
    this.sendTelegramMessage(`
      <b>Appointment Denied</b>
      <b>Appointment ID:</b> ${a.appointmentid}
      <b>Name:</b> ${a.patient_name}
      <b>Phone:</b> ${a.phone}
      <b>Appointment Date & Time:</b> ${this.formatFirestoreDateTime(a.preferredDate)}
      <b>Time:</b> ${a.preferredTime || 'Not specified'}
      <b>Email:</b> ${a.email}
      <b>Service:</b> ${a.service_type}
      <b>Patient Message:</b> ${a.message}
      <b>Notes:</b>
      ${this.formatNotes(a.notes)}
      <b>Status:</b> Denied
      <b>Denied by:</b> ${deniedBy}
      `);
  }
  private formatNotes(notes: any[]): string {
    if (!Array.isArray(notes) || notes.length === 0) {
      return '—';
    }

    return notes
      .map((n, i) => `${i + 1}. ${n.text}`)
      .join('\n');
  }

  private formatFirestoreDateTime(ts: any): string {
    if (!ts || !ts.toDate) return 'Not specified';

    const d: Date = ts.toDate();

    return d.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

async releaseAppointmentTime(a: any) {

  console.log('🔍 Releasing slot for appointment:', a);

  if (!a?.preferredDate || !a?.preferredTime) {
    console.error('❌ Missing preferredDate or preferredTime', a);
    return;
  }

  let date: Date;

  try {
    date = a.preferredDate.toDate();
  } catch (e) {
    console.error('❌ preferredDate is not a Firestore Timestamp', a.preferredDate);
    return;
  }

  const key =
    date.getFullYear() + '-' +
    String(date.getMonth() + 1).padStart(2, '0') + '-' +
    String(date.getDate()).padStart(2, '0');

  console.log('📅 appointmenttimes document id =', key);
  console.log('⏰ removing time =', a.preferredTime);

  const ref = doc(this.firestore, 'appointmenttimes', key);

  try {

    await updateDoc(ref, {
      times: arrayRemove(a.preferredTime)
    });

    console.log('✅ Slot removed successfully');

  } catch (err) {

    console.error('🔥 Failed to remove slot from appointmenttimes', err);

  }
}
async submitNote(a: any) {
  const noteText = a._noteText?.trim();
  if (!noteText) return;

  await updateDoc(
    doc(this.firestore, 'appointments', a.id),
    {
      notes: arrayUnion({
        text: noteText,
        createdAt: Timestamp.now() // ✅ ALLOWED
      })
    }
  );

  a._noteText = '';
}
  sendTelegramMessage(message: string): void {
    this.telegram.sendMessage(message);
  }

  /* ---------------- VISITOR LOGS ---------------- */

  canLoadVisitorLogs(): boolean {
    return !this.visitorLogsLoading && !!this.selectedVisitorRange();
  }

  /* keeps the picker's max date right if the admin page stays open past midnight */
  refreshToday() {
    const now = new Date();
    if (now.toDateString() !== this.today.toDateString()) this.today = now;
  }

  /* Load button — reads the first batch for the selected period (nothing is read before this) */
  loadVisitorLogs() {
    const range = this.selectedVisitorRange();
    if (!range) return;
    this.fetchVisitorLogs(range, this.visitorRangeLabel(range), false);
  }

  /* Load more button — next batch of the period already on screen */
  loadMoreVisitorLogs() {
    if (!this.visitorLoadedRange || !this.visitorHasMore) return;
    this.fetchVisitorLogs(this.visitorLoadedRange, this.visitorLoadedLabel, true);
  }

  private async fetchVisitorLogs(range: { from: Date; to: Date }, label: string, append: boolean) {
    if (!isPlatformBrowser(this.platformId)) return;

    // if Load is pressed again mid-load, only the latest request may update the screen
    const seq = ++this.visitorLoadSeq;
    this.visitorLogsLoading = true;
    this.visitorLogsError = '';

    try {
      const constraints: QueryConstraint[] = [
        where('startedAt', '>=', Timestamp.fromDate(range.from)),
        where('startedAt', '<', Timestamp.fromDate(range.to)),
        orderBy('startedAt', 'desc')
      ];
      if (append && this.visitorLastDoc) constraints.push(startAfter(this.visitorLastDoc));
      // one extra doc tells us whether a "Load more" is really needed
      constraints.push(limit(this.visitorPageSize + 1));

      // server only — never show a partial/empty cached result as if it were the whole period
      const snap = await getDocsFromServer(query(collection(this.firestore, 'visitorlogs'), ...constraints));
      if (seq !== this.visitorLoadSeq) return;

      const docs = snap.docs.slice(0, this.visitorPageSize);
      const rows = docs.map(d => this.toVisitorLogRow(d.id, d.data()));

      this.visitorRows = append ? [...this.visitorRows, ...rows] : rows;
      if (docs.length) this.visitorLastDoc = docs[docs.length - 1];
      else if (!append) this.visitorLastDoc = null;
      this.visitorHasMore = snap.docs.length > this.visitorPageSize;
      this.visitorLoadedRange = range;
      this.visitorLoadedLabel = label;
      this.visitorLogsLoaded = true;

      if (!append) this.visitorLogPaginator?.firstPage();
      this.visitorLogDS.data = this.visitorRows;
      this.computeVisitorStats(this.visitorRows);
    } catch (err) {
      if (seq !== this.visitorLoadSeq) return;
      console.error('Failed to load visitor logs', err);
      this.visitorLogsError = 'Could not load visitor logs. Check the internet connection, and that the Firestore rules allow admins to read the visitorlogs collection.';
    } finally {
      if (seq === this.visitorLoadSeq) this.visitorLogsLoading = false;
    }
  }

  /* selected period as [from, to) in local time — null if the custom range is incomplete */
  private selectedVisitorRange(): { from: Date; to: Date } | null {
    const startOfDay = (d: Date) => {
      const day = new Date(d);
      day.setHours(0, 0, 0, 0);
      return day;
    };
    const daysAfter = (d: Date, days: number) => {
      const day = startOfDay(d);
      day.setDate(day.getDate() + days);
      return day;
    };

    const now = new Date();
    if (this.visitorRange === 'today') return { from: startOfDay(now), to: daysAfter(now, 1) };
    if (this.visitorRange === '7d') return { from: daysAfter(now, -6), to: daysAfter(now, 1) };
    if (this.visitorRange === '30d') return { from: daysAfter(now, -29), to: daysAfter(now, 1) };

    if (!this.customFrom || !this.customTo || this.customFrom > this.customTo) return null;
    return { from: startOfDay(this.customFrom), to: daysAfter(this.customTo, 1) };
  }

  /* e.g. "Today (01 Nov 2026)" — the dates keep the label true even after midnight */
  private visitorRangeLabel(range: { from: Date; to: Date }): string {
    const fmt = (d: Date) => d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    const lastDay = new Date(range.to);
    lastDay.setDate(lastDay.getDate() - 1);
    const dates = range.from.getTime() === lastDay.getTime() ? fmt(range.from) : `${fmt(range.from)} – ${fmt(lastDay)}`;

    const name = this.visitorRange === 'today' ? 'Today'
      : this.visitorRange === '7d' ? 'Last 7 days'
      : this.visitorRange === '30d' ? 'Last 30 days'
      : '';
    return name ? `${name} (${dates})` : dates;
  }

  private toVisitorLogRow(id: string, data: any): VisitorLogRow {
    // the collection is publicly writable, so never trust the shape of a document
    const rawSections = data.sections && typeof data.sections === 'object' ? data.sections : {};
    const secondsFor = (key: string): number => {
      const n = Number(rawSections[key]);
      return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
    };
    const order: string[] = [...new Set<string>([
      ...(Array.isArray(data.sectionOrder) ? data.sectionOrder : []),
      ...Object.keys(rawSections)
    ].filter(key => typeof key === 'string'))];

    const source = data.utmSource
      ? [data.utmSource, data.utmMedium, data.utmCampaign].filter(Boolean).join(' / ')
      : data.referrer || 'Direct';

    const duration = Number(data.durationSeconds);

    return {
      id,
      startedAt: data.startedAt?.toDate?.() ?? null,
      durationSeconds: Number.isFinite(duration) && duration > 0 ? Math.round(duration) : 0,
      sections: order
        .filter(key => secondsFor(key) > 0)
        .map(key => ({ key, label: this.sectionLabel(key), seconds: secondsFor(key) })),
      exitSection: data.exitSection ? this.sectionLabel(data.exitSection) : '',
      device: data.device || '',
      browser: data.browser || '',
      os: data.os || '',
      source,
      visitorId: data.visitorId || id,
      isReturning: !!data.isReturning,
      visitNumber: Number(data.visitNumber) || 1,
      bookedAppointment: !!data.bookedAppointment
    };
  }

  private computeVisitorStats(rows: VisitorLogRow[]) {
    const totalSeconds = new Map<string, number>();  // section key → seconds across all visits
    const visitsSeen = new Map<string, number>();    // section key → visits that saw it

    for (const row of rows) {
      for (const s of row.sections) {
        totalSeconds.set(s.key, (totalSeconds.get(s.key) || 0) + s.seconds);
        visitsSeen.set(s.key, (visitsSeen.get(s.key) || 0) + 1);
      }
    }

    const visits = rows.length;
    const maxSeconds = Math.max(0, ...totalSeconds.values());

    this.sectionStats = TRACKED_SECTIONS.map(s => ({
      label: s.label,
      seconds: totalSeconds.get(s.key) || 0,
      reachPercent: visits ? Math.round(((visitsSeen.get(s.key) || 0) / visits) * 100) : 0,
      barPercent: maxSeconds ? Math.round(((totalSeconds.get(s.key) || 0) / maxSeconds) * 100) : 0
    }));

    const top = this.sectionStats.reduce<SectionStat | null>(
      (best, s) => (s.seconds > (best?.seconds ?? 0) ? s : best), null);

    this.visitorStats = {
      visits,
      uniqueVisitors: new Set(rows.map(r => r.visitorId)).size,
      avgSeconds: visits ? Math.round(rows.reduce((sum, r) => sum + r.durationSeconds, 0) / visits) : 0,
      booked: rows.filter(r => r.bookedAppointment).length,
      topSection: top ? top.label : '—'
    };
  }

  private sectionLabel(key: string): string {
    return this.sectionLabels.get(key) ?? key;
  }

  formatDuration(totalSeconds: number): string {
    const total = Math.max(0, Math.round(totalSeconds || 0));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;

    if (h) return `${h}h ${String(m).padStart(2, '0')}m`;
    if (m) return `${m}m ${String(s).padStart(2, '0')}s`;
    return `${s}s`;
  }

  deviceIcon(device: string): string {
    return device === 'mobile' ? 'smartphone'
      : device === 'tablet' ? 'tablet'
      : device === 'desktop' ? 'computer'
      : 'devices';
  }

  toggleExcludeThisBrowser(exclude: boolean) {
    this.excludeThisBrowser = exclude;
    this.tracking.setOptOut(exclude);
  }

}
